import moment from 'moment'
import memoize from './memoize'

export const scheduleStatuses = {
  PENDING: 'pending',
  CURRENT: 'current',
  EXPIRED: 'expired',
  INVALID: 'invalid',
}

const scheduleStatus = memoize((schedule: App.OfferSchedule) => {
  const now = moment()
  const start = moment(schedule.start)
  const end = moment(schedule.end)

  if (now.isBefore(start)) {
    return scheduleStatuses.PENDING
  }
  else if (now.isAfter(end)) {
    return scheduleStatuses.EXPIRED
  }
  else {
    return scheduleStatuses.CURRENT
  }
})

export function scheduleIsCurrent(schedule?: App.OfferSchedule) {
  return !!schedule && scheduleStatus(schedule) === scheduleStatuses.CURRENT
}
